import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  openingApp: {
    defaultMessage: 'Opening {providerName} App',
    id: 'DeviceHandoff.openingApp',
  },
  open: {
    defaultMessage: 'Open',
    id: 'AwaitingThirdpartyAuthenticationLocalPrompt.open',
  },
});
